import { useState, useEffect } from 'react';
import { getClients } from '../api/scan-api';
import { Client } from '../types';

export const useClients = (shouldFetch: boolean = true, hasActiveProjects: boolean = true) => {
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shouldFetch) return;

    const loadClients = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getClients(hasActiveProjects);
        setClients(data);
      } catch (err: any) {
        console.error('Error loading clients:', err);
        
        // Check for authentication error
        if (err?.status === 403 || err?.status === 401) {
          setError('Authentication required. Please log in first.');
        } else if (err?.status === 404) {
          setError('API endpoint not found. Please check your backend configuration.');
        } else {
          setError(err?.data?.detail || err?.message || 'Failed to load clients');
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadClients();
  }, [shouldFetch, hasActiveProjects]);

  return { clients, isLoading, error };
};

